<template lang="pug">
.catalog-overplot-overlay-layer
  .filtered
    MarkerLayer(v-for="co in frameStore.cos", :key="Id(co)", v-if="co.show", :coord3="co.filteredCoord3", :color="co.color", :marker="co.marker")
  .selected
    MarkerLayer(v-for="co in frameStore.cos", :key="Id(co)", v-if="co.show", :coord3="co.selectedCoord3", :color="[1, 0, 0, 1]", :marker="co.marker")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FrameStore } from "@/modules/base";
import { CatalogOverplotModule } from "@/modules/CatalogOverplotModule";
import MarkerLayer from "./Marker";

@Component({
  components: { MarkerLayer },
})
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof CatalogOverplotModule>
}
</script>